module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "confirm-modal view dark-top",
    attrs: {
      "dialog": "modal-lg"
    }
  }, [_c('div', {
    staticClass: "fs-large mt-4 mb-3 text-center",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "border-bottom-light pb-1"
  }, [_vm._v("\n            " + _vm._s(_vm.modalData.title) + "\n        ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "text-center px-4 pb-4",
    domProps: {
      "innerHTML": _vm._s(_vm.modalData.message)
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "w-100 d-flex justify-content-center"
  }, _vm._l((_vm.modalData.buttons), function(button) {
    return _c('button', {
      class: button.class,
      on: {
        "click": function($event) {
          return _vm.triggerButton(button)
        }
      }
    }, [_vm._v(_vm._s(button.text))])
  }), 0)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-ad5ec98e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad5ec98e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ModalConfirm.vue
// module id = 980
// module chunks = 0